<template>
  <div>
    <h1>Show {{ item && item['@id'] }}</h1>

    <div
      v-if="isLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>
    <div
      v-if="item">
<!--      class="table-responsive">-->
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>createdAt</td>
            <td>{{ item['createdAt'] }}</td>
          </tr>
          <tr>
            <td>updatedAt</td>
            <td>{{ item['updatedAt'] }}</td>
          </tr>
          <tr>
            <td>deletedAt</td>
            <td>{{ item['deletedAt'] }}</td>
          </tr>
          <tr>
            <td>createdBy</td>
            <td>{{ item['createdBy'] }}</td>
          </tr>
          <tr>
            <td>updatedBy</td>
            <td>{{ item['updatedBy'] }}</td>
          </tr>
          <tr>
            <td>deletedBy</td>
            <td>{{ item['deletedBy'] }}</td>
          </tr>
          <tr>
            <td>state</td>
            <td>{{ item['state'] }}</td>
          </tr>
          <tr>
            <td>invoice</td>
            <td>{{ item['invoice'] }}</td>
          </tr>
          <tr>
            <td>item</td>
            <td>{{ item['item'] }}</td>
          </tr>
          <tr>
            <td>customItem</td>
            <td>{{ item['customItem'] }}</td>
          </tr>
          <tr>
            <td>measure</td>
            <td>{{ item['measure'] }}</td>
          </tr>
          <tr>
            <td>quantity</td>
            <td>{{ item['quantity'] }}</td>
          </tr>
          <tr>
            <td>priceNettoPerUnit</td>
            <td>{{ item['priceNettoPerUnit'] }}</td>
          </tr>
          <tr>
            <td>priceNetto</td>
            <td>{{ item['priceNetto'] }}</td>
          </tr>
          <tr>
            <td>vatRate</td>
            <td>{{ item['vatRate'] }}</td>
          </tr>
          <tr>
            <td>vatAmount</td>
            <td>{{ item['vatAmount'] }}</td>
          </tr>
          <tr>
            <td>priceBrutto</td>
            <td>{{ item['priceBrutto'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <router-link
      v-if="item"
      :to="{ name: 'EXSBInvoicePositionList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="deleteItem(item)">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: mapGetters({
    deleteError: 'exsbinvoiceposition/del/error',
    error: 'exsbinvoiceposition/show/error',
    isLoading: 'exsbinvoiceposition/show/isLoading',
    item: 'exsbinvoiceposition/show/retrieved'
  }),

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'exsbinvoiceposition/del/del',
      reset: 'exsbinvoiceposition/show/reset',
      retrieve: 'exsbinvoiceposition/show/retrieve'
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'EXSBInvoicePositionList' }))
      }
    }
  }
}
</script>
